import axios from "axios";

const API_URL = import.meta.env.VITE_APP_API_URL;

export interface DrpOption {
	id: number;
	name: string;
	type_id: number;
}

export const fetchDrpListByDistrict = async (
	districtId: number | string,
): Promise<DrpOption[]> => {
	const response = await axios.get(`${API_URL}/admin/hlc/drp-list`, {
		params: { district_id: districtId },
	});
	return response.data?.data ?? [];
};

export const generateHlcRegistrationNo = async (params: {
	scheme_id: number | string;
	target_scheme_name: string;
	district_id: number | string;
	hlc_no: string;
	proceeding_no: string;
	proceeding_date: string;
}): Promise<string> => {
	const response = await axios.get(
		`${API_URL}/admin/hlc/generate-registration-no`,
		{ params },
	);
	return response.data?.data?.registration_no ?? "";
};
